import Router from 'next/router'
import EmailPasswordReact from 'supertokens-auth-react/recipe/emailpassword'
import PasswordlessReact from 'supertokens-auth-react/recipe/passwordless'
import SessionReact from 'supertokens-auth-react/recipe/session'
import { appInfo } from './appInfo'

const COOKIE_DOMAIN = process.env.NODE_ENV === 'development' ? 'localhost' : '.app.gmb.io';

export const frontendConfig = () => {
  return {
    appInfo,
    recipeList: [
      EmailPasswordReact.init({
        useShadowDom: false,
      }),
      PasswordlessReact.init({
        contactMethod: "EMAIL",
        useShadowDom: false,
      }),
      SessionReact.init({
        sessionTokenBackendDomain: COOKIE_DOMAIN,
      }),
    ],
    windowHandler: (oI: any) => {
      return {
        ...oI,
        location: {
          ...oI.location,
          setHref: (href: string) => {
            Router.push(href)
          },
        },
      }
    },
  }
}